<section class="navigation-container">
    <div class="inner-container grid-container">
        <div class="nav-menu-item" #navMenuItem *ngFor="let item of items">
            <app-menu-link [navigationItem]="item" [activeItem]="activeItem" (click)="
            item.pageLinksCollection && activeItem === item.navigationTitle
              ? setActiveItem(null)
              : setActiveItem(item.navigationTitle, navMenuItem)" (megaMenuClosed)="closeMenu()"></app-menu-link>
        </div>

        <!-- desktop search modal -->
        <div class="search-desktop" *ngIf="isSearchEnable" clickOutside (clickOutside)="isSearchOpen=false;">
            <button class="search-icon"
                (click)="openSearchBox()" [ariaLabel]="isSearchOpen ? 'Close search' : 'Open search'"
                [ngClass]="{ activeSearch: isSearchOpen }">
                  <i class="far fa-times" [class.hide]="!isSearchOpen"></i>
                  <i class="far fa-search" [class.hide]="isSearchOpen"></i>
            </button>
            <div class="search-modal desktop" *ngIf="isSearchOpen && isDesktop" [class.activeSearch]="isSearchOpen">
                <app-search-modal [searchItems]="searchItems" [isSearchOpen]="isSearchOpen" (closeSearch)="isSearchOpen=false"></app-search-modal>
            </div>
        </div>
    </div>
</section>